<div class="traveller hoverarea">

    <div class="excerpt traveller-part">
        <span class="part">

            <div class="traveller-review">
                <div>
                    <strong class="key">{{travellerKey}}</strong>
                    <strong class="title-lastName-firstName">
                        <ng-container *ngIf="travellerItem.title">{{t_title[travellerItem.title]}}</ng-container>
                        <ng-container *ngIf="!travellerItem.title">{{ Yii.t('wui-shared-js', 'M.') }}</ng-container>
                        {{travellerItem.lastName}} {{travellerItem.firstName}}</strong>
                    <span class="type">{{typeCode[travellerItem.type]}}{{travellerItem.personType}}</span>
                </div>
                <!-- <div *ngIf="isDetails" (click)="showDetails = !showDetails; showMessage = !showMessage" >
                    <i class="fa" [ngClass]="{ 'fa-eye': !showDetails, 'fa-eye-slash': showDetails }"></i>
                </div> -->

                <btn type="invisible" (click)="shDetails()" *ngIf="isDetails && !travellerItem.dataToPatch" click-stop>
                    <span class="icon">
                          <i class="fa" [ngClass]="{ 'fa-eye': !showDetails, 'fa-eye-slash': showDetails }"></i>
                    </span>
                </btn>
                <btn type="invisible" (click)="shDetails()" *ngIf="isDetails && travellerItem.dataToPatch" click-stop>
                    <span class="icon">
                        <fa-icon [icon]="showDetails ? iconEyeSlash : iconEye"></fa-icon>
                        <fa-icon [icon]="iconExclamation"></fa-icon>
                    </span>
                </btn>

                <span class="part" *ngIf="travellerItem.journey">
                        <btn
                          type="actionMore"
                          *ngIf="getJourneyType() === 'PNR'"
                          [label]="getJourneyType()"
                          [value]="getJourneyValue()"
                          (click)="showPnr( getJourneyType(), getJourneyValue() )"
                          minWidth="minWidthSmall"
                          click-stop></btn>
                        <btn
                          type="actionMore"
                          *ngIf="getJourneyType() === 'NAMELIST'"
                          [label]="getExportName(getJourneyValue())"
                          (click)="showNamelist(getJourneyType(), getJourneyValue(), getJourneyId())"
                          minWidth="minWidthSmall"
                          click-stop></btn>
                        <btn
                          type="invisible"
                          *ngIf="isJourneyError()"
                          [label]="Yii.t('wui-shared-js', 'Erreur d\'association')"
                          click-stop></btn>
                </span>
                <span class="part" *ngIf="travellerItem.booking">

                        <btn
                          type="actionMore"
                          [label]="getBookingType()"
                          [value]="getBookingValue()"
                          (click)="showTnr( getBookingType(), getBookingValue() ); pop = !pop"
                          minWidth="minWidthSmall"
                          ></btn>

                          <btn
                            type="actionUndo"
                            *ngIf="travellerItem.isAdded"
                            (click)= "removeMe()"
                            click-stop>
                              <span class="icon">
                                <fa-icon [icon]="iconUserTimes"></fa-icon>
                              </span>
                          </btn>

                </span>
            </div>


            <btn *ngIf="message" label="{{errorLabel}}" type="warning">
                <span class="icon">
                    <fa-icon [icon]="iconExclamation"></fa-icon>
                </span>
            </btn>
            
    </span>

</div>
<div class="alert traveller-part" [class.showDetails]="showMessage" *ngIf="message">

    <message type="warning" fullwidth="true" [value]="message"></message>

</div>

<div class="details" [class.showDetails]="showDetails">

    <div class=" ctn ctn-left ctn-wrap">
        <div class="item-sep" *ngIf="travellerItem.birthDate">
            <span class="label">{{t_nele}}</span>
            <strong>{{travellerItem.birthDate | dateMoment: dateFormat.momentShort}}</strong>
        </div>
        <!-- Not the same key for kuoni side and pnr/namelist side ... -->
        <div class="item-sep" *ngIf="travellerItem.dateOfBirth">
            <span class="label">{{t_nele}}</span>
            <strong>{{travellerItem.dateOfBirth | dateMoment: dateFormat.momentShort}}</strong>
        </div>

        <div class="item-sep" *ngIf="travellerItem.givenNames">
            <span class="label">{{t_autresprenoms}}</span>
            <strong *ngFor="let names of travellerItem.givenNames; let l = last">{{names}}<ng-container *ngIf="!l">, </ng-container></strong>
        </div>

        <div class="item-sep" *ngIf="travellerItem.citizenship">
            <span class="label">{{t_nationalite}}</span>
            <strong>{{travellerItem.citizenship}}</strong>
        </div>

        <ng-container *ngIf="travellerItem.passport">
            <div class="item-sep" [class.showDetails]="showDetails">
                <span class="label">{{t_passeport}}</span>
                <strong>{{travellerItem.passport.number}}</strong>
            </div>
            <div class="item-sep">
                <span class="label">{{Yii.t('wui-shared-js', 'Pays d\'émission')}}</span>
                <strong>{{travellerItem.passport.issuance.country}}</strong>
            </div>
            <div class="item-sep">
                <span class="label">{{t_expirele}}</span>
                <strong>{{travellerItem.passport.validity.end | dateMoment: dateFormat.momentShort}}</strong>
            </div>

        </ng-container>

        <ng-container *ngIf="travellerItem.identityCard">
            <div class="item-sep" [class.showDetails]="showDetails">
                <span class="label">{{Yii.t('wui-shared-js',"Carte d'identité")}}</span>
                <strong>{{travellerItem.identityCard.number}}</strong>
            </div>
            <div class="item-sep">
                <span class="label">{{Yii.t('wui-shared-js', 'Pays d\'émission')}}</span>
                <strong>{{travellerItem.identityCard.issuance.country}}</strong>
            </div>
            <div class="item-sep">
                <span class="label">{{t_expirele}}</span>
                <strong>{{travellerItem.identityCard.validity.end | dateMoment: dateFormat.momentShort}}</strong>
            </div>

        </ng-container>





    </div>
</div>

<div>
